// @flow
import authenticatedRequest from './authenticated-request'
import { addErrorNotification } from './notification-manager'

import type { GetState, Dispatch, ReduxAction } from './index'
import type { NetError } from './authenticated-request'
import { isAdmin } from './authentication'

const dataUrl: string = '/api/campaigns'

// Action types
export const FETCH_ALLOWED_CAMPAIGNS_PENDING: 'allowedCampaigns/FETCH_ALLOWED_CAMPAIGNS_PENDING' =
  'allowedCampaigns/FETCH_ALLOWED_CAMPAIGNS_PENDING'
export const FETCH_ALLOWED_CAMPAIGNS_SUCCESS: 'allowedCampaigns/FETCH_ALLOWED_CAMPAIGNS_SUCCESS' =
  'allowedCampaigns/FETCH_ALLOWED_CAMPAIGNS_SUCCESS'
export const FETCH_ALLOWED_CAMPAIGNS_ERROR: 'allowedCampaigns/FETCH_ALLOWED_CAMPAIGNS_ERROR' =
  'allowedCampaigns/FETCH_ALLOWED_CAMPAIGNS_ERROR'
export const SET_CURRENT_CAMPAIGN: 'allowedCampaigns/SET_CURRENT_CAMPAIGN' = 'allowedCampaigns/SET_CURRENT_CAMPAIGN'

export type ACTION_FETCH_ALLOWED_CAMPAIGNS_PENDING = {| type: typeof FETCH_ALLOWED_CAMPAIGNS_PENDING |}
export type ACTION_FETCH_ALLOWED_CAMPAIGNS_SUCCESS = {|
  type: typeof FETCH_ALLOWED_CAMPAIGNS_SUCCESS,
  payload: Array<string>,
|}
export type ACTION_FETCH_ALLOWED_CAMPAIGNS_ERROR = {| type: typeof FETCH_ALLOWED_CAMPAIGNS_ERROR, payload: NetError |}
export type ACTION_SET_CURRENT_CAMPAIGN = {| type: typeof SET_CURRENT_CAMPAIGN, payload: string |}

export type AllowedCampaignsAction =
  | ACTION_FETCH_ALLOWED_CAMPAIGNS_PENDING
  | ACTION_FETCH_ALLOWED_CAMPAIGNS_SUCCESS
  | ACTION_FETCH_ALLOWED_CAMPAIGNS_ERROR
  | ACTION_SET_CURRENT_CAMPAIGN

type AllowedCampaignsState_ = {|
  currentCampaign: string,
  allowedCampaigns: Array<string>,
  loading: boolean,
|}
export type AllowedCampaignsState = $Shape<AllowedCampaignsState_>

// Initial state
export const initialState: AllowedCampaignsState = {
  currentCampaign: '',
  allowedCampaigns: [],
  loading: false,
}

// Reducer
export const reducer = (state: AllowedCampaignsState = initialState, action: ReduxAction): AllowedCampaignsState => {
  switch (action.type) {
    case FETCH_ALLOWED_CAMPAIGNS_PENDING:
      return { ...state, loading: true }
    case FETCH_ALLOWED_CAMPAIGNS_SUCCESS:
      return { ...state, allowedCampaigns: action.payload, loading: false }
    case FETCH_ALLOWED_CAMPAIGNS_ERROR:
      return { ...state, loading: false }
    case SET_CURRENT_CAMPAIGN:
      return { ...state, currentCampaign: action.payload }
    default:
      return state
  }
}
export default reducer

// Action creators
export const setCurrentCampaign = (campaignName: string): ACTION_SET_CURRENT_CAMPAIGN => ({
  type: SET_CURRENT_CAMPAIGN,
  payload: campaignName,
})

export const fetchAllowedCampaigns = async (getState: GetState) => {
  let response = await authenticatedRequest.get(dataUrl)
  let campaigns = response.data.data
  let allowedCampaigns = []
  for (let c of campaigns) {
    let users = c.users.map(el => el.username)
    let user = getState().auth.data.credentials.user || {}
    if ('username' in user && users.indexOf(user.username) !== -1 && (c.active || isAdmin(getState()))) {
      allowedCampaigns.push(c.name)
    }
  }
  return allowedCampaigns
}

export const getAllowedCampaigns = () => async (dispatch: Dispatch, getState: GetState) => {
  dispatch({ type: FETCH_ALLOWED_CAMPAIGNS_PENDING })
  try {
    let allowedCampaigns = await fetchAllowedCampaigns(getState)
    dispatch({ type: FETCH_ALLOWED_CAMPAIGNS_SUCCESS, payload: allowedCampaigns })
  } catch (err) {
    dispatch({ type: FETCH_ALLOWED_CAMPAIGNS_ERROR, payload: err })
    dispatch(addErrorNotification(err.response.data.message))
  }
}



// WEBPACK FOOTER //
// ./src/store/allowed-campaigns.js